<template>
  <div class="centerPage">
    <div class="centerPage_bigTitle">
      <a href="/">
        <img src="~images/logo.svg" alt="" />
      </a>
      Sign Up to EZ Retro
    </div>
    <div class="centerPage_whiteBox whiteBox">
      <form>
        <label>Name</label>
        <input class="input" v-model.trim="signupForm.name" placeholder="John Appleseed" type="text" autocomplete="name" />

        <label>Email</label>
        <input class="input" v-model.trim="signupForm.email" placeholder="john@appleseed.com" type="email" autocomplete="username email" />

        <label>Password</label>
        <input class="input" v-model.trim="signupForm.password" placeholder="••••••••••••" type="password" autocomplete="new-password" />

        <div v-if="errorMsg !== ''" class="error-msg">
          {{ errorMsg }}
        </div>
        <button type="button" :disabled="loading" @click="signup" v-bind:class="[loading ? 'loading' : '', 'button']">
          Sign Up
        </button>
      </form>
    </div>

    <div class="centerPage_whiteBox centerPage_whiteBox_additional">
      Already have an account?
      <router-link class="centerPage_forgotPass_link" to="login">
        Sign in
      </router-link>
    </div>
  </div>
</template>

<script>
import firebaseFirestore ,{ AUTH, ANALYTICS } from 'src/firebase-config';
export default {
  data() {
    return {
      signupForm: {
        name: '',
        email: '',
        password: ''
      },
      errorMsg: '',
      loading: false
    };
  },
  methods: {
    signup() {
      this.loading = true;
      AUTH.createUserWithEmailAndPassword(this.signupForm.email, this.signupForm.password)
        .then(async user => {
          this.$store.commit('setCurrentUser', user);

          firebaseFirestore.collection('usersInfo').doc(user.user.uid)
            .set({
              email:this.signupForm.email,
              name: this.signupForm.name,
              notifications:true
            })
            .then(() => {
              this.loading = false;
              ANALYTICS.logEvent('user_created',{
                fromInvite:false,
                email:this.signupForm.email,
              });
              AUTH.currentUser.sendEmailVerification().then(()=>{
                this.$router.push('/dashboard');
              })
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
              this.errorMsg = err.message;
            });
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.errorMsg = err.message;
        });
    }
  },
  beforeMount() {
    if (AUTH.currentUser) {
      this.$router.push('/dashboard');
    }
  },
  mounted() {
    ANALYTICS.logEvent('page_view');
  }
};
</script>

<style></style>
